import React from "react"
import RcmpLink from "../../../components_v2/atoms/Link";
import ArrowRightIcon from "../../../assets_v2/icons/ArrowRightIcon";

import styles from './index.module.scss';

function RcmpItem(props) {
  const { bActive, children, as, ...oRest } = props;

  const className = `${styles.breadCrumbItem} ${bActive ? styles.breadCrumbActiveItem : ""}`;

  if (bActive) {
    return (
      <p className={className} {...oRest}>
        {children}
      </p>
    );
  }

  if (as === "a") {
    return (
      <a className={className} {...oRest}>
        {children}
      </a>
    );
  }

  return (
    <RcmpLink className={className} {...oRest}>
      {children}
    </RcmpLink>
  );
}


function RcmpMainBreadCrumb(props) {
  const { children, className, ...oRest } = props;

  const nTotalChidrens = React.Children.toArray(children)?.length

  const classes = `${styles.breadCrumbContainer} ${className ? className : ""}`

  return (
    <div className={classes} {...oRest}>
      {React.Children.map(children, (c, nIndex) => (
        <>
          {React.cloneElement(c)}
          {(nTotalChidrens > (nIndex + 1)) && (<ArrowRightIcon />)}
        </>
      ))}
    </div>
  );
}

const RcmpBreadCrumb = Object.assign(RcmpMainBreadCrumb, { RcmpItem })


export default RcmpBreadCrumb;